<template>
  <div class="com">
    <div class="col">
      <div class="col-item">
        <div class="title">
          KIT ID:
        </div>
        <div class="info">
          <span class="info-item kit-id">{{
            convertKitId(testKitDetails.kit_id)
          }}</span>
        </div>
      </div>
      <div class="col-item">
        <div class="title">
          Your Profile:
        </div>
        <div class="info">
          <span class="info-item">   
            {{ userInfo.first_name + " " + userInfo.last_name }}
          </span>
          <span class="info-item">{{ contacts.mail }}</span>
          <span class="info-item">{{ makePhone(contacts.phone) }}</span>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="col-item">
        <div class="title">
          Samples Collected by:
        </div>
        <div class="info">
          <span class="info-item">
            {{
              testKitDetails.collected_first_name + " " + testKitDetails.collected_last_name
            }}
          </span>
        </div>
      </div>
      <div class="col-item">
        <div class="title">
          Sampling Date:
        </div>
        <div class="info">
          <span class="info-item">{{ date(testKitDetails.sampling_date) }}</span>
        </div>
      </div>
      <div class="col-item">
        <div class="title">
          Sampling Location:
        </div>
        <div class="info">
          <span class="info-item">
            {{
              testKitDetails.address +
                ", " +
                testKitDetails.city +
                ", " +
                testKitDetails.state +
                ", " +
                testKitDetails.zip
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="col-item" v-for="(item, index) in testKitDetails.indoor_samples">
        <div class="title">Indoor Sample #{{ index + 1 }}:</div>
        <div class="info">
          <span class="info-item">{{ item.type }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";

export default {
  name: "FinalInfo",
  mixins: [parseAndConvertKitId],
  computed: {
    ...mapGetters(["userInfo", "contacts", "testKitDetails"])
  },
  methods: {
    date(localDate) {
      return moment(localDate).format("MMMM D, YYYY");
    },
    makePhone(phone) {
      if (phone) {
        // Check if phone is null or undefined
        if (phone === null || phone === undefined) {
          return null;
        }

        // Remove any non-digit characters from the input
        const cleanPhone = phone.replace(/\D/g, '');

        // Check if the cleaned phone number is exactly 10 digits
        if (cleanPhone.length === 11 || cleanPhone.length === 10) {
          const phoneArr = cleanPhone.split("");
          let  convertedPhone = null;
          if (cleanPhone.length === 11){
          convertedPhone = `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${phoneArr[5]}${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${phoneArr[10]}`;
          } else if (cleanPhone.length === 10) {
          convertedPhone = `(${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${phoneArr[3]}${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}`;
          }
          return convertedPhone;
        } else {
          return null;
        }
      }
    }
  },
  created() {
    if (this.$route.query.step && !this.userInfo.collected_first_name) {
      this.$store.dispatch(
        "userInfo",
        this.$store.getters.userInfo.testkits[0]
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.com {
  padding: 36px 10px 5px 10px;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: space-between;
}
.col {
  width: 100%;
  max-width: 190px;
  display: flex;
  align-self: center;
  flex-direction: column;
}
.col-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 16px;
  line-height: 20px;
}
.info {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.title {
  color: $gray;
  font-size: 16px;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.info-item {
  color: $gray;
  font-size: 16px;
  text-align: center;
  font-family: TTNormsRegular, sans-serif;
  display: block;
  line-height: 1.4;
  &.kit-id {
    text-transform: uppercase;
  }
}
@media (max-width: 568px) {
  .com {
    flex-direction: column;
    align-items: center;
  }
  .info-item {
    max-width: 100%;
  }
}
</style>
